
import Vue, { PropType } from 'vue'
import { RButton } from '@/components'
import { AvailableTools } from './types'

export default Vue.extend({
  name: 'ItemListingToolbox',
  components: {
    RButton,
  },
  props: {
    tools: {
      type: Object as PropType<AvailableTools>,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
})
